// AccordionContext.tsx
import React, {createContext, useContext, useState, ReactNode} from 'react'

type AccessesAccordionContextType = {
    expandedItems: string[]
    expandItem: (id: string) => void
    collapseItem: (id: string) => void
    collapseAll: () => void
}

const AccessesAccordionContext = createContext<AccessesAccordionContextType | undefined>(undefined)

type AccessesAccordionContextProviderProps = {
    children: ReactNode
}

export const AccessesAccordionContextProvider: React.FC<AccessesAccordionContextProviderProps> = ({children}) => {
    const [expandedItems, setExpandedItems] = useState<string[]>([])

    const expandItem = (id: string) => {
        setExpandedItems(items => (items.includes(id) ? items : [...items, id]))
    }

    const collapseItem = (id: string) => {
        setExpandedItems(items => items.filter(itemId => itemId !== id))
    }

    const collapseAll = () => {
        setExpandedItems([])
    }

    return (
        <AccessesAccordionContext.Provider value={{expandedItems, expandItem, collapseItem, collapseAll}}>
            {children}
        </AccessesAccordionContext.Provider>
    )
}

// Custom hook per accedere al context
export const useAccessesAccordion = (): AccessesAccordionContextType => {
    const context = useContext(AccessesAccordionContext)
    if (!context) {
        throw new Error('useAccessesAccordion must be used within an AccessesAccordionContextProvider')
    }
    return context
}
